<template>
  <footer class="global-footer">
    <div class="footer-content">
      <!-- Logo and tagline on the left -->
      <div class="footer-logo">
        <router-link to="/" aria-label="Back to Engagr home">
          <img src="/assets/engagr-wh.svg" alt="Engagr Logo" class="logo" />
        </router-link>
        <div class="tagline">
          <p>Spotlighting Happy Customers.</p>
          <p>Share their stories. Build your business.</p>
        </div>
      </div>
      
      <!-- Copyright text on the right -->
      <div class="footer-text">
        <p>© engagr. All rights reserved. Powered by <a href="https://adme.net.au/" target="_blank" rel="noopener noreferrer" class="adme-link">ADME</a>.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.global-footer {
  position: relative;
  background-color: #1a1a1a;
  color: white;
  z-index: 100;
  border-top: 1px solid #333;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 16px;
}

.footer-logo .logo {
  height: 40px;
  width: auto;
}

.tagline {
  color: #e0e0e0;
  font-size: 14px;
  line-height: 1.4;
}

.tagline p {
  margin: 0;
}

.footer-text {
  font-size: 14px;
  color: #cccccc;
}

.footer-text p {
  margin: 0;
}

.adme-link {
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.adme-link:hover {
  color: #007bff;
  text-decoration: underline;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    text-align: center;
  }
  
  .footer-logo {
    flex-direction: column;
    gap: 12px;
  }
  
  .footer-logo .logo {
    height: 32px;
  }
  
  .tagline {
    font-size: 13px;
    text-align: center;
  }
  
  .footer-text {
    font-size: 12px;
  }
}

/* Extra small screens */
@media (max-width: 480px) {
  .footer-content {
    padding: 16px;
  }
  
  .footer-logo .logo {
    height: 28px;
  }
  
  .tagline {
    font-size: 12px;
  }
  
  .footer-text {
    font-size: 11px;
  }
}
</style>
